import BrandLogo from "/static/images/tenants/keychron/keychron_white.svg";
import { keychronContent } from "../brandContent/keychronBrandContent";
import { keychronVertical } from "../brandThemes/keychron-v";
import { keychronPrize } from "../brandPrize/keychronPrize";

export const KEYCHRONVERTICAL_brandVariables = {
  tenantId: "keychron-kzk8f", // For picking wich leaderboard to show
  themeId: "keychron",
  gameStyle: "cs2timed", // For picking wich leaderboard to show
  eventCode: "", // Needed for fetching correct challenge
  gameType: "CSGO", // What challenge game
  brandLogoType: "element", // "img" | "element" (svg)
  brandLogo: BrandLogo,
  brandLogoSize: 400,
  theme: keychronVertical,
  content: keychronContent,
  prize: keychronPrize,

  leaderboardLength: 10,
  disclaimer: "Set the fastest time and win a",
};
